import { render } from "./supportTicket.vue?vue&type=template&id=99c2d300"
import script from "./supportTicket.vue?vue&type=script&lang=js"
export * from "./supportTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__